export const freezeBody = (doFreeze: boolean): void => {
  if (typeof window === 'undefined') return;
  const body = document.body;

  const scrollbarWidth = getScrollBarWidth();

  body.classList.toggle('_freeze', doFreeze);
  document.documentElement.classList.toggle('_freeze', doFreeze);

  if (doFreeze) {
    body.style.top = `-${window.scrollY}px`;

    body.style.position = 'fixed';

    if (document.dir === 'rtl') {
      body.style.paddingLeft = scrollbarWidth + 'px';
    } else {
      body.style.paddingRight = scrollbarWidth + 'px';
    }
  } else {
    const top = window.getComputedStyle(body).top;

    const scrollToY = parseInt(top || '0') * -1;

    body.removeAttribute('style');

    if (scrollToY) window.scrollTo(0, scrollToY);
  }
};

export const getScrollBarWidth = (): number => {
  const outer = document.createElement('div');

  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (outer.style as any).msOverflowStyle = 'scrollbar';

  document.body.appendChild(outer);

  const inner = document.createElement('div');

  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  if (outer.parentNode) {
    outer.parentNode.removeChild(outer);
  }

  return scrollbarWidth;
};
